const ITEMS = [
  "24/7 Emergency Response",
  "Water Damage Extraction",
  "Fire & Smoke Restoration",
  "Mold Remediation",
  "Biohazard Sanitization",
  "Full Home Rebuild Services",
  "Fox Valley Wisconsin & Beyond",
];

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-[#0B0B10] py-5"
      data-testid="service-marquee"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex items-center">
            {ITEMS.map((item) => (
              <span
                key={`${item}-${copy}`}
                className="font-mono-data flex items-center text-[10px] uppercase tracking-[0.35em] text-slate-500 sm:text-xs"
              >
                <span className="px-8">{item}</span>
                <span className="text-purple-500/70">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
